import type { StatusPresentation } from '@/utils/labels';

/** Automatic content (ADR-0051) in the editor's words. */

export const CONTENT_STATE: Record<string, StatusPresentation> = {
  idea: { tone: 'unknown', label: 'Тема', glyph: '○', hint: 'Ждёт решения: написать или отклонить' },
  queued: { tone: 'pending', label: 'В очереди', glyph: '◌', hint: 'Будет написана в ближайшие минуты' },
  writing: { tone: 'pending', label: 'Пишется', glyph: '◌', hint: 'Claude собирает материал и пишет' },
  ready: { tone: 'maintenance', label: 'Готова', glyph: '◆', hint: 'Написана и ждёт публикации' },
  publishing: { tone: 'pending', label: 'Публикуется', glyph: '◌', hint: 'Отправляется в CMS' },
  published: { tone: 'healthy', label: 'В CMS', glyph: '●', hint: 'Опубликована или сохранена черновиком' },
  failed: { tone: 'down', label: 'Ошибка', glyph: '■', hint: 'Написание или публикация не удались' },
  rejected: { tone: 'unknown', label: 'Отклонена', glyph: '×', hint: 'Не будет написана' },
};

export const CONTENT_MODE_LABELS: Record<string, string> = {
  review: 'Проверка в панели',
  wp_draft: 'Черновик в WordPress',
  publish: 'Публикация по графику',
};

export const CONTENT_MODE_HINTS: Record<string, string> = {
  review: 'Статья ждёт в панели, публикует редактор',
  wp_draft: 'Статья уходит в WordPress черновиком',
  publish: 'Статья публикуется сама, равномерно по неделе',
};

export const CONTENT_ORIGIN_LABELS: Record<string, string> = {
  person: 'Вручную',
  ideas: 'Предложена',
  autopilot: 'Автопилот',
};

export function formatUsd(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  return new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
}

/** Which half of the writing an article is in, as the list says it. */
export const CONTENT_STAGE_LABELS: Record<string, string> = {
  research: 'поиск материала',
  writing: 'пишется текст',
};
